export const numberFormat = (number:number) => {
    return new Intl.NumberFormat('ja-JP').format(number);
};

export const numberFormatWithK = (number:number) => {
    if(number === 0) return "0";
    const absNumber = Math.abs(number);
    const sign = Math.sign(number) === -1 ? "-" : "";
    if(absNumber >= 1000) {
        const formattedNumber = absNumber >= 1000000 ? (absNumber / 1000000).toFixed(1) + "M" : (absNumber / 1000).toFixed(1) + "K";
        return sign + formattedNumber;
    }
    return sign + new Intl.NumberFormat('ja-JP').format(number);
};
